import React from 'react';

interface IPersonIcon {
  height?: number;
  width?: number;
  fill?: string;
}

const PersonIcon: React.FC<IPersonIcon> = props => {
  const { height = 12, width = 12, fill = 'none' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.11714 7.55854L7.78286 7.43854C7.74064 7.42297 7.70413 7.39498 7.67812 7.35826C7.65211 7.32155 7.63782 7.27781 7.63714 7.23282V6.5214C7.63861 6.49174 7.64622 6.46271 7.6595 6.43615C7.67278 6.40959 7.69144 6.38608 7.71429 6.36711C8.06274 6.01644 8.28827 5.56236 8.35714 5.07282C8.34538 5.03955 8.34538 5.00324 8.35714 4.96997C8.45877 4.83154 8.53163 4.67416 8.57143 4.50711C8.62386 4.33058 8.6395 4.14516 8.61739 3.96234C8.59527 3.77952 8.53587 3.60319 8.44286 3.44425C8.75971 2.78277 8.89857 2.05009 8.84571 1.31854C8.65714 0.392824 7.49143 0.0156809 6.45429 0.0156809C6.07105 -0.0246567 5.68362 0.0130254 5.31534 0.126456C4.94706 0.239886 4.60556 0.426715 4.31143 0.675681C4.29859 0.696803 4.28112 0.714726 4.26032 0.728091C4.23953 0.741457 4.21597 0.749914 4.19143 0.752823C3.94112 0.807317 3.71892 0.950379 3.56571 1.15568C3.41343 1.49537 3.3347 1.86342 3.3347 2.23568C3.3347 2.60794 3.41343 2.976 3.56571 3.31568C3.57823 3.34403 3.5847 3.37469 3.5847 3.40568C3.5847 3.43667 3.57823 3.46733 3.56571 3.49568C3.3921 3.79968 3.34295 4.15909 3.42857 4.49854C3.46683 4.66874 3.53977 4.82923 3.64286 4.96997C3.65462 5.00324 3.65462 5.03955 3.64286 5.07282C3.71173 5.56236 3.93726 6.01644 4.28571 6.36711C4.307 6.38684 4.32405 6.41069 4.33584 6.43721C4.34762 6.46374 4.3539 6.49237 4.35429 6.5214V7.23282C4.3536 7.27781 4.33932 7.32155 4.31331 7.35826C4.2873 7.39498 4.25079 7.42297 4.20857 7.43854L3.87429 7.55854C2.16 8.19282 0.908571 8.65568 0.522857 9.42711C0.199981 10.1028 0.0218885 10.8385 0 11.5871C0 11.7008 0.0451529 11.8098 0.125526 11.8902C0.205898 11.9705 0.314907 12.0157 0.428571 12.0157H11.5714C11.6851 12.0157 11.7941 11.9705 11.8745 11.8902C11.9548 11.8098 12 11.7008 12 11.5871C11.9731 10.8437 11.7921 10.1141 11.4686 9.44425C11.0829 8.65568 9.84 8.19282 8.11714 7.55854Z"
        fill="#0276FE"
      />
    </svg>
  );
};

export default PersonIcon;
